module.exports = __webpack_public_path__ + "img/question-mark.1309f184.svg";